export const register_title = 'Register to Join the Regulatory Agency Program';
export const register_content =
  'By submitting this form you are agreeing to participate in the BREEZE Regulatory Agency Program and comply with the stated expectations in exchange for free use of BREEZE air dispersion modeling software.';
export const InformationTitle = 'Your Information';
export const companyTitle = 'Agency Information';
export const link = 'Join the Program';
